import { fiflboxApi } from '@/utils/api';

const state = {
  policy: {
    membership_system: null,
    booking_available_from: null,
    booking_available_to: null,
    booking_changeable_to: null,
    booking_cancellable_to: null,
    booking_expired_time: null,
    attendance_available_from: null,
    late_from: null,
    remind_alarm_time: null,
    is_remaining_quota_exposed: true,
    is_remind_alarm_avaliable: false
  }
};

const getters = {
  getPolicy(state) {
    return state.policy;
  },
  getMembershipSystem(state) {
    if (state.policy.membership_system === 'POINT') {
      return {
        short: 'P',
        middle: 'P',
        long: '포인트',
        value: 'POINT'
      };
    }

    if (state.policy.membership_system === 'COUNT') {
      return {
        short: '회',
        middle: '횟수',
        long: '횟수',
        value: 'COUNT'
      };
    }

    return {
      short: '',
      middle: '',
      long: '',
      value: ''
    };
  }
};

const actions = {
  async syncPolicy({ commit }) {
    try {
      let { data: policy } = await fiflboxApi.v2.getPolicy();

      commit('setPolicy', policy);
    } catch (err) {
      console.log(err);
    }
  }
};

const mutations = {
  setPolicy(state, policy) {
    state.policy = policy;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
